<template>
    <main>
        <h1>Debe iniciar sesión, para continuar</h1>
    </main>
</template>

<script>
export default {};
</script>

<style></style>
